export default __webpack_public_path__ + "static/media/r3.5dc74eaf.svg";